<template>
  <div>
    <!-- 新增用户对话框 -->
    <el-dialog title="编辑客户" append-to-body :visible.sync="dialogVisible"  width="70%" :before-close="handleClose">
      <!-- 用户信息表单 -->
      <el-form ref="addClientForm" :model="form" :rules="rules"  label-position="left" label-width="100px" style="padding: 0 16px;">
        <el-row style="margin-bottom: 10px;" :gutter="40">
          <el-col :span="8">
            <el-form-item prop="fullName" label="客户全称">
              <el-input class="form-select" v-model.trim="form.fullName" placeholder="请输入客户全称" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户行业">
              <el-input class="form-select" v-model.trim="form.work" placeholder="请输入客户行业" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所处地区">
              <el-input class="form-select" v-model.trim="form.group" placeholder="请输入客户所处地区" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="8">
            <el-form-item label="销售组">
              <el-input v-model="form.group"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户经理">
              <el-input v-model="form.boss"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commitAddClient">确 定</el-button>
        <el-button  @click="commitAddClient">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "addClient",
  data() {
    return {
      dialogVisible: false,
      form:{
        account_manager:'', // 基金经理
        client_id:'',
        group:'',
        place:'',
        work:'',
        client_name:'', // 客户全称
      },
      rules: {
        fullName: [
          {required: true, message: '客户全程不能为空'}
        ]
      }

    };
  },
  props:{
    // 父组件传递过来的控制
    value:{
      required:true,
      default:false,
      type:Boolean
    },
    ClientData:{
      required:true
    }
  },
  watch:{
    value(val){
      this.dialogVisible = val
    }
  },
  methods: {
    handleClose(done) {
      // alert(11111)
      this.$emit('input',false)
    },
    commitAddClient(){
      this.$emit('input',false)
    }
  }
}
</script>

<style scoped>

</style>